import { Pessoa } from "./pessoa.model";
import { Plano } from "./plano.model";
import { WebEsteiraStatus } from "./webEsteiraStatus.model";
import { WebTipoProcesso } from "./webTipoProcesso.model";

export class WebTempTermoExtratoBPD {
    idTermo: number;
    pessoa: Pessoa;
    plano: Plano;
    dtSolicitacao: Date;
    idTipoBPD: number;
    nrSeq: number;
    vlBPD: number;
    qtCotaBPD: number;
    nmOpcaoBPD: string;
    nmProtocolo: string;
    webTipoProcesso: WebTipoProcesso;
    webEsteiraStatus: WebEsteiraStatus;
    token: string;
    ipSolicitacao: string;
    nmContratoSemAssinatura: string;
    nmAssinatura: string;
    nmContratoAssinado: string;
    nmRelatorioAssinatura: string;
    nmTermoOpcao: string;
    nmCodTermoOpcao: string;
    nmExtratoPrevidenciario: string;
    nmCodExtratoPrevidenciario: string;
    dtDesistenciaContrato: Date;
    nmMotivoDesistencia: string;
}